/**
 * Format a statement date (date-only semantics) as short m/d/yy.
 *
 * Statement dates come back as UTC ISO strings ("2026-06-11T00:00:00.000Z").
 * Feeding those through `new Date(...).toLocaleDateString()` shifts them into
 * the viewer's timezone and shows the PREVIOUS day for anyone west of UTC —
 * so the calendar date is taken from the ISO string directly, no Date math.
 */
export function formatStatementDate(
	value: string | Date | null | undefined,
): string {
	if (value == null || value === '') {
		return '-';
	}
	const iso = typeof value === 'string' ? value : value.toISOString();
	const datePart = iso.split('T')[0];
	const [year, month, day] = datePart.split('-');
	// Malformed input leaves month/day undefined at runtime; the NaN check
	// below catches it (parseInt(undefined) is NaN).
	const monthNum = parseInt(month, 10);
	const dayNum = parseInt(day, 10);
	if (Number.isNaN(monthNum) || Number.isNaN(dayNum)) {
		return '-';
	}
	return `${monthNum}/${dayNum}/${year.slice(2)}`;
}
